<template>
  <div>
    <!-- 大图预览模态框 -->
    <el-dialog
        title="图片预览"
        :visible.sync="dialogVisible"
        width="50%"
        center>
      <div style="text-align: center;">
        <img :src="previewImage" alt="大图预览" style="max-width: 100%; max-height: 500px;background-color: #f5f5f5;">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关 闭</el-button>
        <el-button type="primary" @click="closeDialog">确定</el-button>
        <!--        <el-button type="primary" @click="downloadImage">下载图片</el-button>-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "previewImageDialog",
  props: {
    // 预览图片的地址
    previewImage: {
      type: String,
      default() {
        return "";
      }
    },
    // 文件名字
    filename: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    downloadImage() {
      if (!this.previewImage) return;

      // 1. 判断图片类型
      const isNetworkImage = this.previewImage.startsWith('http');

      if (isNetworkImage) {
        // 网络图片：新窗口打开（立即可用）
        this.$message.info('图片即将在新窗口打开，请右键另存为');
        setTimeout(() => {
          window.open(this.previewImage, '_blank');
        }, 1000)
      } else {
        // 本地/上传图片：原有方式
        const link = document.createElement('a');
        link.href = this.previewImage;
        link.download = this.filename || '公告图片';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success('图片下载成功');
      }
    },
    // 关闭弹框
    closeDialog() {
      this.dialogVisible = false;
    },
    // 打开弹框
    openDialog() {
      this.dialogVisible = true;
    }
  }
}
</script>

<style scoped>

</style>